<template>
  <div>
    <div class="header" v-if="(!loading && most_clicked.length) || query.length">
      <h1>Most Clicked</h1>
    </div>
    <div v-if="(results.data && results.data.length) || query.length">
      <el-table :data="most_clicked" style="width: 100%;" v-loading="loading">
        <el-table-column label="Link">
          <template slot-scope="scope">
            <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
              <a :href="scope.row.link" target="_blank">{{ scope.row.link }}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Count" fixed="right" align="right">
          <template slot-scope="scope">
            {{ scope.row.count | prettyNumber }}
          </template>
        </el-table-column>
      </el-table>

      <div class="header">
        <h1>Clicked</h1>
      </div>

      <el-table :data="results.data" style="width: 100%;" v-loading="loading">
        <el-table-column label="Email Address">
          <template slot="header" slot-scope="scope">
            <el-input v-model="query" size="mini" placeholder="Search" @change="searchData" />
          </template>
          <template slot-scope="scope">
            <a :href="'/contacts/' + scope.row.contact_uuid" target="_blank">{{ scope.row.email }}</a>
          </template>
        </el-table-column>
        <el-table-column label="Link">
          <template slot-scope="scope">
            <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
              <a :href="scope.row.link" target="_blank">{{ scope.row.link }}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Last Click At" fixed="right" align="right">
          <template slot-scope="scope">
            {{ scope.row.latest_timestamp | humanDateTime }}
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 2rem;">
        <el-pagination layout="total, prev, pager, next" :total="results.total" :page-size="results.per_page"
                       @next-click="nextPage" @prev-click="prevPage" @current-change="currentPage"
                       style="text-align: center;"></el-pagination>
      </div>
    </div>

    <div class="illustration" v-if="!loading && results.data && !results.data.length && !query.length">
      <img src="https://assets.brandbot.com/public/empty-states/analytics-clicked.svg" />
    </div>
  </div>
</template>
<script>
  import _ from 'lodash';
  import * as api from '@/api';

  export default {
    props: ['typeUuid'],
    data() {
      return {
        query: '',
        loading: true,
        results: {},
        most_clicked: [],
        page: 1,
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      searchData: _.debounce(function customFunc() {
        api.emailPerformanceContacts(this.typeUuid, 'click', this.page, this.query).then((response) => {
          this.$set(this, 'results', response.contacts);
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      }, 200,
      ),
      fetchData() {
        this.loading = true;
        api.emailPerformanceContacts(this.typeUuid, 'click', this.page, this.query).then((response) => {
          this.$set(this, 'results', response.contacts);
          this.most_clicked = response.most_clicked;
          this.loading = false;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      nextPage() {
        this.page += 1;
        this.fetchData();
      },
      prevPage() {
        this.page = this.page - 1;
        this.fetchData();
      },
      currentPage(page) {
        this.page = page;
        this.fetchData();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .header {
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1 {
    text-transform: capitalize;
    font-size: 1.25rem;
    font-weight: normal;
    color: #212B36;
    line-height: 1.5rem;
  }

  .illustration img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 10rem;
    margin-bottom: 2rem;
  }
</style>
